<div class="country-select">

  <!-- Selected value -->
  <div class="selected" (click)="toggleDropdown()">

    <ng-container *ngIf="selectedCountry; else placeholder">
      <span class="label">Pays :</span>
      <span class="value">{{ selectedCountry.name }}</span>
    </ng-container>

    <ng-template #placeholder>
      <span class="placeholder">Choisir un pays</span>
    </ng-template>

  </div>

  <!-- Dropdown -->
  <div class="dropdown" *ngIf="isOpen">

    <!-- Search -->
    <input
      type="text"
      [(ngModel)]="search"
      (input)="filterCountries()"
      placeholder="Rechercher un pays..."
    />

    <!-- 🔹 Select all -->
    <div class="item select-all" (click)="selectAll()">
      🌍 Tous les pays
    </div>

    <!-- Countries list -->
    <div
      class="item"
      *ngFor="let country of filteredCountries"
      (click)="selectCountry(country)"
    >
      {{ country.name }}
    </div>

  </div>

</div>
